"use client";
import React from "react";
import { Modal } from "react-bootstrap";
import CommonButton from "./CommonButton";

const ConfirmModal = ({ show, onHide, primaryBtn, secondBtn }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>
          Ready to get started? —<span>Let’s choose your next step</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-0">
        <p className="mb-3 text-center">
          You can create a brand new estimate or review an existing one.
        </p>
        <p className="mb-3 text-center">
          <strong>Your data is always safe and private — no pressure.</strong>
        </p>
        <div className="d-flex justify-content-end gap-3">
          <CommonButton
            label="Show Existing Estimate"
            className="black-border"
            variant="outline"
            onClick={secondBtn}
          />
          <CommonButton
            label="Create New Estimate"
            className="btn-primary"
            onClick={primaryBtn}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmModal;
